/* eslint-disable react-hooks/rules-of-hooks */
import _ from 'lodash';
import { useContext } from 'react';
import copilot from '@janus.team/janus-copilot/cjs/janus-copilot';
import { NewProductModelClient } from '@rss-engineering/product-model-tools';
import { proxyFetch } from '../fetch';

// Service Levels
const AVIATOR = 'gcp.aviator';
const RUNWAY = 'gcp.runway';
const serviceLevels = [
  AVIATOR,
  RUNWAY,
];

const getProductModelClient = _.memoize(() => NewProductModelClient({
  baseUrl: process.env.REACT_APP_PRODUCT_MODEL_URL,
  fetch: proxyFetch,
}));

const buildCatalog = (rawProducts) => _(rawProducts)
  .omit('sha')
  .filter((product) => product.allowedAccountTypes.includes('MANAGED_GCP'))
  .mapKeys('extensions.janusGcp.serviceBlockId')
  .mapValues((product) => ({
    ...product.extensions.janusGcp,
    ...product.extensions.cmsAddon,
  }))
  .value();

const fetchProductModel = async () => {
  const client = getProductModelClient();
  const products = await client.getProducts({ version: process.env.REACT_APP_PRODUCT_MODEL_VERSION }).then(buildCatalog);
  return products;
};

const allServiceBlocks = (products) => _.map(products, (product) => product.serviceBlockId);

const isServiceLevel = (serviceLevel) => _.some(serviceLevels, (knownServiceLevel) => knownServiceLevel === serviceLevel);

const serviceLevelLabel = (serviceLevel) => _.get({
  [AVIATOR]: 'Aviator',
  [RUNWAY]: 'Runway',
}, serviceLevel, serviceLevel);

const getServiceBlockName = (products, id) => {
  const serviceBlock = _.get(products, id);
  return _.get(serviceBlock, 'name', id);
};

const getCompatibleServiceBlocks = (products, baseServiceBlock) => {
  const serviceBlock = _.get(products, baseServiceBlock, {});
  const incompatibilities = _.get(serviceBlock, 'incompatibilities', []);
  return _.difference(allServiceBlocks(products), incompatibilities);
};

const getDefaultBaseServiceBlock = (products) => {
  const defaultBaseServiceBlock = _.find(products, 'isDefault');
  return _.get(defaultBaseServiceBlock, 'serviceBlockId');
};

const userHasChangeServiceLevelPermission = () => _.some(_.split(process.env.REACT_APP_UPDATE_SERVICE_LEVEL_GROUPS, ','), (group) => _.find(_.get(useContext(copilot.context.session), ['session', 'user', 'roles']), ['name', group]));

const isBaseServiceBlock = (serviceBlockId, products) => {
  const serviceBlock = _.get(products, serviceBlockId, {});
  return _.get(serviceBlock, 'isBase', false);
};

export {
  allServiceBlocks,
  buildCatalog,
  fetchProductModel,
  getCompatibleServiceBlocks,
  getDefaultBaseServiceBlock,
  getServiceBlockName,
  isBaseServiceBlock,
  isServiceLevel,
  serviceLevelLabel,
  serviceLevels,
  userHasChangeServiceLevelPermission,
};
